module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am374-b27fa08e4c50b6e9aa576ef77f5977a6.jpg";